import React, { useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

function Tooltip({ message, children }) {
  const [position, setPosition] = useState(null);
  const tooltipRef = useRef(null);

  const show = (event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    setPosition({
      x: rect.left + rect.width / 2,
      top: rect.top,
      bottom: rect.bottom,
    });
  };

  useLayoutEffect(() => {
    if (!position || position.y !== undefined || !tooltipRef.current) return;
    const { width, height } = tooltipRef.current.getBoundingClientRect();
    const margin = 8;
    const x = Math.max(width / 2 + margin, Math.min(window.innerWidth - width / 2 - margin, position.x));
    const fitsAbove = position.top - margin >= height;
    const y = fitsAbove
      ? position.top - margin
      : Math.min(window.innerHeight - height - margin, Math.max(margin, position.bottom + margin));
    const placement = fitsAbove ? 'above' : 'below';
    if (position.x !== x || position.y !== y || position.placement !== placement) {
      setPosition({ ...position, x, y, placement });
    }
  }, [position]);

  return (
    <span className="ui-tooltip" onMouseEnter={show} onMouseLeave={() => setPosition(null)} onFocus={show} onBlur={() => setPosition(null)}>
      {children}
      {position && createPortal(
        <span ref={tooltipRef} className={`ui-tooltip-message ${position.placement || 'above'}`} style={{ left: position.x, top: position.y }}>{message}</span>,
        document.body,
      )}
    </span>
  );
}

export default Tooltip;